import { requireAdmin } from "./auth.js";

document.addEventListener("DOMContentLoaded", () => {
  const adminOnlyElement = document.querySelector("[data-admin-only]");
  if (!adminOnlyElement) return;
  requireAdmin();
});
